<script lang="ts">
    import { onMount } from 'svelte'
    import { ChartService, type ChartBarsSeries, type ChartData } from './zchart'
    import Zframe from './zframe.svelte'

    export let data: ChartData

    export { className as class }
    let className = ''

    const chart = new ChartService()

    let chartContainer

    function loadChart(_data) {
        if (!data) return
        console.log('chart load')
        if (data.type === 'bars') {
            chart.bars(_data, chartContainer)
        }
        if (data.type === 'donut') {
            chart.donut(_data, chartContainer)
        }
        if (data.type === 'line') {
            chart.line(_data, chartContainer)
        }
    }

    onMount(() => {})

    $: {
        loadChart(data)
    }
</script>

<Zframe title={data?.title} headline={data?.headline || ''} class={className || ''}>
    <div bind:this={chartContainer} />
</Zframe>

<style>
</style>
